import { coreApi } from '../api'

async function fetchData(applicationId) {
  const { data: response } = await coreApi.get(
    `/loan/auto-refi/bkf/applications/${applicationId}`,
  )

  const filterIncludedDataByType = type => {
    return response.included.filter(inc => inc.type === type)[0]
  }

  return {
    cellphone: {
      number: response.included[0].attributes.contactCellphone,
      code: response.included[0].attributes.contactCellphoneCode,
    },
    email: response.included[0].attributes.contactEmail,
    vehicleOwner: response.data.attributes.vehicleOwner,
    employments: {
      professionalStatus: filterIncludedDataByType(
        'loan auto-refi bkf employments',
      ).attributes.professionalStatus,
    },
    people: {
      id: filterIncludedDataByType('loan auto-refi bkf people').id,
    },
  }
}

export { fetchData }
